<template>
  <div class="page" :style="{backgroundImage:'url('+activtiyInfo.activityCover+')'}">
    <Map v-if="showMap" :windowHeight="windowHeight" v-on:success="success" />
    <div :style="{visibility: !activtiyInfo.hideTitle ? 'inherit':'hidden'}" class="activtiy-name">
      {{String(activtiyInfo.activityName || '').substring(0,10)}}
    </div>
    <div :style="{visibility: !activtiyInfo.hideTitle ? 'inherit':'hidden'}" class="activtiy-times">
      {{String(activtiyInfo.startTime || '').substring(5,10).replace(/-/,'月') + '日'}}  ~  {{String(activtiyInfo.endTime || '').substring(5,10).replace(/-/,'月') + '日'}}
    </div>
    <div class="tit top">
      <span>店铺信息（必填）</span>
    </div>
    <div class="box">
      <van-cell-group>
        <van-field v-model="params.storeName" label="店铺名称" placeholder="请输入店铺名称" />
        <van-field v-model="params.storeTradeArea" label="店铺地址" placeholder="点击选择" @click="showMap = true" readonly/>
        <van-field v-model="params.fullAddress" label="门牌号" placeholder="请输入门牌号" />
        <van-field
          readonly
          clickable
          label="经营类目"
          :value="storeProductName"
          placeholder="点击选择您的经营类目"
          @click="showPicker = true"
        >
          <template #button>
            <van-icon name="arrow" />
          </template>
        </van-field>
        <van-popup v-model="showPicker" round position="bottom">
          <van-picker
            show-toolbar
            value-key="name"
            :columns="columns"
            @cancel="showPicker = false"
            @confirm="onConfirm"
          />
        </van-popup>
      </van-cell-group>
    </div>
    <div class="tit">
      <span>联系方式（必填）</span>
    </div>
    <div class="box">
      <van-cell-group>
        <van-field label-width="0" v-model="params.storeContactPhone" placeholder="请输入手机号码" />
      </van-cell-group>
    </div>
    <div class="tit flex-jb-c">
      <span>店铺图片（必填）</span>
      <div class="example-btn" @click="example = true">
        查看示例
      </div>
    </div>
    <div class="box">
      <UploadImg v-on:successImg="successImg" :pic="params.storeIcon" />
    </div>
    <!-- <div class="tit">
      <span>宣传视频（选填）</span>
    </div>
    <div class="box">
      <van-uploader v-model="fileList" :after-read="afterRead" />
    </div> -->
    <div class="tit">
      <span>店铺简介（选填）</span>
    </div>
    <div class="box">
      <van-cell-group>
        <van-field v-model="params.storeIntroduction" label-width="0" placeholder="请输入选手简介" rows="2" type="textarea" />
      </van-cell-group>
    </div>
    <div class="agreement-warp">
      <div class="agreement-oper">
        <van-checkbox icon-size="16px" checked-color="#FF9A32" v-model="agreementChecked" /><span style="margin-left: 5px" @click="toAgreement">报名即代表您同意<用户协议及隐私政策></span>
      </div>
    </div>
    <div class="foot-warp">
      <a class="contact-service"  @click="csDialog">
        <van-icon name="service-o"  class="icon" />
        <div class="text">客服</div>
      </a>
      <div class="foot-btn" @click="onSubmit">
        提交
      </div>
    </div>
    <!-- 报名成功 -->
    <van-overlay :show="cg.dialog" >
      <div class="dialog-wrap">
        <div class="cg-dialog">
          <img class="top-bg" src="@/assets/images/activity/enroll.png" alt="" />
          <div class="tips-warp-t">您的报名已提交成功，请等待主办方审核，</div>
          <div class="tips-warp-t">审核通过后将以短信告知您。</div>
          <div class="tip-block">
            <div class="block-p">
              尊敬的商家
            </div>
            <div class="ab-warp">
              <img class="icon-ab" src="@/assets/images/activity/enroll-ab.png" alt="" />
              <div>
                入驻响锣店群
              </div>
              <img class="icon-ab" src="@/assets/images/activity/enroll-ab.png" alt="" />
            </div>
            <div class="block-p">
              能增加店铺的曝光率和可信度
            </div>
            <div class="block-p">
              排名提升更快哦~
            </div>
          </div>
          <div class="u-btn" @click="toReceive">
            立即入驻，提升曝光
          </div>
          <div class="anu-btn" @click="$router.go(-1)">
            暂不入驻
          </div>
        </div>
      </div>
    </van-overlay>
    <!-- 主办发客服 -->
    <van-overlay :show="cs.dialog" >
      <div class="dialog-wrap">
        <div class="cs-dialog">
          <div class="cs-title">主办方客服</div>
          <img src="@/assets/images/activity/qrcode.jpg"  class="img" alt="" />
          <div class="cs-sub">长按识别添加客服微信</div>
          <div class="van-icon van-icon-cross dialog-close" @click="cs.dialog = false"></div>
          <a :href="`tel:${activtiyInfo.hostContactPhone}`" class="u-dialog-btn">
            <i class="iconfont icon-phone-channel"></i>
            <span class="text">拨打电话</span>
          </a>
        </div>
      </div>
    </van-overlay>
    <van-overlay :show="example" >
      <div class="dialog-wrap">
        <img class="example" src="@/assets/images/common/store-example.png" alt="">
        <a class="u-dialog-btn" @click="example = false">
          <span class="text">知道了</span>
        </a>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import Map from '../../components/map/map'
import UploadImg from '../../components/upload/uploadImg'
import WxValidate from '@/util/WxValidate'

export default {
  data () {
    return {
      windowHeight: document.documentElement.clientHeight,
      agreementChecked: true,
      cg: {
        dialog: false
      },
      cs: { // 客服
        dialog: false
      },
      act: {
        activityStatus: 0,
        totalActivityAccessNum: 0
      },
      params: {
        id: '',
        storeName: '',
        fullAddress: '',
        storeContactPhone: '',
        lat: '',
        lng: '',
        productType: '',
        storeTradeArea: '',
        storeIcon: '',
        storePromotionalVideo:'',
        storeIntroduction: ''
      },
      activtiyInfo: {},
      activtiyId: '',
      showPicker: false,
      columns: [],
      fileList: [],
      showMap: false,
      poiaddress: '',
      storeProductName: '',
      storeId: '',
      example: false
    }
  },
  components: {
    Map,
    UploadImg
  },
  created () {
    this.activtiyId = this.$route.query.activtiyId
    console.log(this.$route.query)
    this.params.id = this.$route.query.activtiyId
    this.withChildren()
    this.getActivtiyInfo()
    //初始化validate
    this.initValidate()
  },
  methods: {
    toAgreement() {
      this.$router.push({
        path: '/activity/agreement'
      })
    },
    successImg(e){
      this.params.storeIcon = e
    },
    toReceive() {
      this.$router.push({
        path: '/store/receive',
        query: { id: this.storeId,type: '1' }
      })
    },
    csDialog () {
      this.cs.dialog = true
    },
    //表单验证
    initValidate() {
      let rules = {
        storeName: {
          required: true,
          maxlength: 20
        },
        storeTradeArea: {
          required:true
        },
        fullAddress: {
          required:true
        },
        productType: {
          array:true
        },
        storeContactPhone:{
          required:true,
          tel: true
        },
        storeIcon:{
          required:true
        }
      }
      let message = {
        storeName: {
          required: '请输入店铺名称',
          maxlength: '店铺名称不能超过20个字'
        },
        storeTradeArea: {
          required: '请选择地址'
        },
        fullAddress: {
          required: '请输入门牌号'
        },
        productType: {
          array: '请选择经营类目'
        },
        storeContactPhone:{
          required: '请输入联系电话',
          tel: '电话号码有误'
        },
        storeIcon:{
          required: '请上传店铺图片'
        }
      }
      //实例化当前的验证规则和提示消息
      this.WxValidate = new WxValidate(rules, message);
    },
    async getActivtiyInfo () {
      const result = await this.$api.activity.getIndexVoteActivityInfo({ id: this.activtiyId })
      this.activtiyInfo = result.data
    },
    async withChildren () {
      const result = await this.$api.store.withChildren()
      this.columns = result.data
    },
    success (e) {
      this.showMap = false
      this.params.lat = e.latlng.lat
      this.params.lng = e.latlng.lng
      this.params.storeTradeArea = e.poiaddress
    },
    onConfirm (e) {
      this.showPicker = false
      this.params.productType = [e.id]
      this.storeProductName = e.name
    },
    afterRead (file) {
      file.status = 'uploading'
      file.message = '上传中...'
      setTimeout(() => {
        file.status = 'failed'
        file.message = '上传失败'
      }, 1000)
    },
    onSubmit () {
      if (!this.agreementChecked) {
        this.$toast('请勾选用户协议')
        return false
      }
      if (!this.WxValidate.checkForm(this.params)) {
        const error = this.WxValidate.errorList[0]
        this.$toast(error.msg)
        return false
      }
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      this.$api.activity.addVoteActivityStore(this.params).then(res => {
        this.$toast.clear()
        if (res.status === 0) {
          this.cg.dialog = true
          this.storeId = res.data
        }
        else{
          this.$toast(res.details)
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>

  @import "~@/assets/css/var.less";
  
  .page{
    box-sizing: border-box;
    padding-top: 50px;
    padding-bottom: 70px;
    background-repeat: no-repeat;
    background-size: 100%;
  }
  .flex-jb-c{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .example-btn{
    width: 68px;
    height: 24px;
    background: #FFFFFF;
    border: 1px solid #E5E5E5;
    border-radius: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    color: #666666;
    margin-right: 15px;
  }
  .example{
    width: 275px;
    height: 203px;
  }
  .dialog-close {
    position: absolute;
    right: 0.15rem;
    top: 0.15rem;
    width: 0.23rem;
    height: 0.23rem;
    font-size: 0.23rem;
    line-height: 0.23rem;
    text-align: center;
    color: #CDCDCD;
  }
  .dialog-wrap{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .u-dialog-btn {
      background-color: #F87D1D;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 0.4rem;
      width: 1.7rem;
      border-radius: 0.2rem;
      margin: 0.25rem auto 0 auto;
      color: #fff;
    }
    height: 100%;
    .cg-dialog{
      position: relative;
      width: 275px;
      background: #FFFFFF;
      border-radius: 5px;
      padding-top: 70px;
      padding-bottom: 25px;
    }
    .top-bg{
      width: 194px;
      height: 96px;
      position: absolute;
      top: -35px;
      left: 43px;
    }
    .tips-warp-t{
      font-size: 11px;
      color: #9A9A9A;
      line-height: 20px;
      text-align: center;
    }
    .tip-block{
      width: 230px;
      height: 135px;
      border: 2px dashed #F77C1C;
      border-radius: 5px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-content: center;
      margin: 12px auto;
    }
    .block-p{
      font-size: 15px;
      color: #666666;
      text-align: center;
      line-height: 21px;
    }
    .ab-warp{
      display: flex;
      justify-content: center;
      align-items: flex-start;
      margin: 12px 0;
      >div{
        font-size: 18px;
        font-weight: bold;
        color: #F87E1E;
        margin: 0 12px;
      }
    }
    .icon-ab{
      width: 16px;
      height: 8px;
    }
    .u-btn{
      margin: 0 auto;
      margin-top: 18px;
      width: 200px;
      height: 40px;
      background: #F87E1E;
      border-radius: 20px;
      font-size: 15px;
      font-weight: bold;
      color: #FFFFFF;
      display: flex;
      justify-content: center;
      align-content: center;
    }
    .anu-btn{
      margin: 0 auto;
      margin-top: 15px;
      width: 48px;
      height: 12px;
      font-size: 12px;
      font-weight: bold;
      color: #CCCCCC;
    }

    .cs-dialog{
      background-color: #fff;
      border-radius: 5px;
      width: 275px;
      padding:  30px 0;
      position: relative;

      .cs-title{
        font-size: 16px;
        color: #333;
        text-align: center;
      }

      .img{
        height: 150px;
        width: 150px;
        display: block;
        margin: 13px auto 0 auto;
      }

      .cs-sub{
        font-size: 10px;
        color: #999;
        line-height: 1;
        padding-top: 5px;
        text-align: center;
      }
    }
  }
  .activtiy-name{
    font-size: 30px;
    font-weight: bold;
    color: #FFFFFF;
    text-align: center;
  }
  .activtiy-times{
    font-size: 12px;
    font-weight: bold;
    color: #FFFFFF;
    text-align: center;
    margin-top: 10px;
  }
  .tit{
    box-sizing: border-box;
    font-size: 12px;
    color: #9A9A9A;
    display: flex;
    padding-left: 31px;
    margin: 20px 0 10px;
  }
  .tit.top{
    margin-top: 36px;
    color: #ffffff;
  }
  .box{
    width: 92%;
    background: #FFFFFF;
    border-radius: 10px;
    margin: 0 auto;
  }
  .foot-warp{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;

    .contact-service{
      width: 125px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      background-color: #ffffff;
      .icon{
        font-size: 20px;
        line-height: 20px;
        width: 40px;
        color: #999;
        text-align: center;
      }
      .text{
        padding-top: 5px;
        font-size: 11px;
        line-height: 1;
        color: #999;
      }
    }
  }
  .foot-btn{
    width: 250px;
    height: 49px;
    background: #FF9A32;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 15px;
    font-weight: bold;
    color: #FFFFFF;
  }
  .agreement-warp{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px 0;
    .tips{
      display: flex;
      justify-content: center;
      font-size: 11px;
      color: #FD8D18;
      margin-bottom: 7px;
    }
    .agreement-oper{
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 11px;
      color: #9A9A9A;
    }
  }

</style>
